import getAdjustedIconClassName from 'owa-mini-icons/lib/utils/getAdjustedIconClassName';
import React from 'react';
import { CalendarEvent } from 'mini-calendar-event-types';
import { getRsvpUnitIcon } from '../utils/getRsvpUnitIcon';
import { isItemSenderTheMeetingAttendee } from 'mini-meeting-invite/lib/utils/isItemSenderTheMeetingAttendee';

const styles = require('./RsvpUnit.scss');
const classNames = require('classnames/bind').bind(styles);

export const RsvpBarIcon = ({ item }: { item: CalendarEvent }) => {
    // get all the icon details
    const { icon, iconStyles, badge } = getRsvpUnitIcon(item);
    const { ResponseType } = item;
    const iconWithoutResponse = (
        <i className={classNames(getAdjustedIconClassName(icon), iconStyles)} aria-hidden="true" />
    );
    const iconWithResponse = (
        <div className={styles.iconWithResponseContainer}>
            <i className={classNames(getAdjustedIconClassName(icon), iconStyles)} aria-hidden />
            <i
                className={classNames(getAdjustedIconClassName(badge), styles.responseStatus, {
                    accept: ResponseType === 'Accept',
                    decline: ResponseType === 'Decline',
                    tentative: ResponseType === 'Tentative',
                })}
                aria-hidden
            />
        </div>
    );
    return isItemSenderTheMeetingAttendee(item as any) && item.IsRespondedEvent
        ? iconWithResponse
        : iconWithoutResponse;
};
